module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/is-vux-wechat-official-project-46.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/faq/is-vux-wechat-official-project.md
// module id = 748
// module chunks = 428